<aside class="sidebar shadow-sm">
  <div
    class="sidebar-profile d-flex flex-column justify-content-center pt-5 pb-3"
  >
    <div class="picture-wrapper mb-4">
      <div class="user-picture m-auto">
        <img
          [src]="storeLogo || './assets/img/user.jpg'"
          (error)="onLogoError()"
          class="img-fluid"
          alt="Perfil"
        />
      </div>
    </div>
    <div class="profile-details text-center pb-4">
      <p class="mb-0 text-uppercase name">{{ userName }}</p>
      <small class="text-uppercase role">Administrator</small>
    </div>
  </div>
  <div class="sidebar-search pt-1 pb-1 pl-3 pr-3">
    <input
      type="search"
      class="form-control rounded-pill"
      name="search"
      placeholder="Search ..."
    />
  </div>
  <nav class="sidebar-menu pt-3 pb-3">
    <div class="menu-header mt-3 mb-2">Menu</div>
    <ul class="menu-items">
      <li *ngFor="let menu of menus" [class.disabled]="!menu.menu_active">
        <a
          *ngIf="menu.menu_active"
          [routerLink]="menu.menu_route"
          routerLinkActive="active"
          [pTooltip]="menu.menu_name"
          tooltipPosition="right"
          [tooltipDisabled]="!isCollapsed"
          appendTo="body"
        >
          <i class="pi pi-desktop" *ngIf="!menu.menu_icon"></i>
          <i [class]="menu.menu_icon" *ngIf="menu.menu_icon"></i>
          <span>{{ menu.menu_name }}</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>
